import { createTV } from 'tailwind-variants';

import { twMergeConfig } from './utils';

/** tailwind-variants, merging classes with the same token-aware config as `cn`. */
export const tv = createTV({ twMergeConfig });
